package top.wcpe.allincore.ui.runtime.element

/**
 * 滚动装饰器抽象基类：包裹型容器，接收一个 [ScrollableContainer] 作为 body 子元素，在其外层叠加
 * 交互/视觉层（下拉刷新、上拉加载、自动滚动等）。
 *
 * 设计原则：装饰器不通过继承叠加能力，而是组合一个滚动容器作为 body；装饰器自身负责拦截/转发事件
 * 并维护自己的状态机，不修改 body 的滚动语义。
 *
 * body 通过 [body] 设置时同时作为唯一子节点加入，故装饰器布局上等同于「单子容器」，由布局引擎按其
 * 自身尺寸约束 body。
 *
 * @param SELF 自类型，便于链式 API
 */
abstract class ScrollDecorator<SELF : ScrollDecorator<SELF>> : UIElement<SELF>() {

    /** 被装饰的滚动容器 body。供子类按 bodyField 访问（原 Java protected 字段名 body）。 */
    protected var bodyField: ScrollableContainer<*>? = null

    /** 设置 body 并作为子节点加入。重复调用以最后一次为准（不清理旧 body 子节点，由调用方保证只设一次）。 */
    fun body(body: ScrollableContainer<*>?): SELF {
        bodyField = body
        if (body != null) {
            child(body)
        }
        return self()
    }

    /** 当前 body；未设置时返回 null。 */
    fun body(): ScrollableContainer<*>? = bodyField

    /**
     * 内部 API：仅设置 body 引用，不再把它加为子节点。
     * 供 IR 层使用——子节点已在遍历中单独 child(...) 加入，此处只补 body 引用，避免 [body] 重复 child
     * 导致同一元素出现两次。
     */
    fun bodyInternal(body: ScrollableContainer<*>?) {
        bodyField = body
    }
}
